import React from 'react';
import { FEATURED_STORIES } from '../data/partners';
import { mediaUrl } from '../utils/mediaUrl';
import AnimatedSection from './AnimatedSection';
import './ProofSection.css';

const ProofSection = () => (
  <section className="proof section" id="work-proof">
    <div className="container">
      <AnimatedSection>
        <p className="section-label">/ Work</p>
        <h2 className="section-title">Built for hard environments.</h2>
        <p className="section-subtitle">
          Official partners, a live product, and production AI shipped for
          companies that cannot afford demo theater.
        </p>
      </AnimatedSection>

      <div className="proof-list">
        {FEATURED_STORIES.map((spot, i) => (
          <AnimatedSection key={spot.id} delay={i * 0.08} className="proof-item">
            <div className={`proof-media proof-media--${spot.accent || 'case'}`}>
              {spot.mediaType === 'video' && spot.video ? (
                <video
                  muted
                  playsInline
                  preload="metadata"
                  poster={mediaUrl(spot.poster)}
                  src={mediaUrl(spot.video)}
                  onMouseEnter={(e) => e.currentTarget.play().catch(() => {})}
                  onMouseLeave={(e) => {
                    e.currentTarget.pause();
                    e.currentTarget.currentTime = 0;
                  }}
                />
              ) : (
                <img
                  src={mediaUrl(spot.image)}
                  alt={spot.title}
                  loading="lazy"
                />
              )}
            </div>
            <div className="proof-copy">
              <p className="section-label">{spot.label}</p>
              <h3>{spot.title}</h3>
              <p>{spot.summary}</p>
              <a
                href={spot.href}
                className="proof-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open site →
              </a>
            </div>
          </AnimatedSection>
        ))}
      </div>
    </div>
  </section>
);

export default ProofSection;
